import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { FeatureFlagEnvelope } from '@cdaas/api-clients/dist/asset-feature-flag-openapi';
import { FeatureFlags } from '../utils';
import { RootState } from '.';

type FeatureFlagsState = FeatureFlags;

// Add here all needed feature flags in alphabetical order
export const initialUiState: FeatureFlagsState = {
  FEATURE_FLAG_EMAIL_UPDATE_ENABLED: false,
  FEATURE_FLAG_FRONTEND_FLOW_BUYOUT_WITH_PRICE_ENABLED: false,
  FEATURE_FLAG_MAINTENANCE_MODE_ENABLED: false,
  FEATURE_FLAG_MANAGED_RETURN_FI_ENABLED: false,
  FEATURE_FLAG_MANAGED_RETURN_NO_ENABLED: false,
  FEATURE_FLAG_MANAGED_RETURN_SE_ENABLED: false,
  FEATURE_FLAG_PIM_AND_USER_GROUP_ROLES_ENABLED: false,
  FEATURE_FLAG_RECURRING_MONTHLY_EXTENSION_FI_ENABLED: false,
  FEATURE_FLAG_RECURRING_MONTHLY_EXTENSION_NO_ENABLED: false,
  FEATURE_FLAG_RECURRING_MONTHLY_EXTENSION_SE_ENABLED: false,
  FEATURE_FLAG_USER_OFFBOARDING_ENABLED: false,
};

const featureFlags = createSlice({
  name: 'featureFlags',
  initialState: { ...initialUiState },
  reducers: {
    setFeatureFlags: (_state, action: PayloadAction<FeatureFlagEnvelope>) => action.payload.feature_flags as unknown as FeatureFlagsState,
  },
});

export const { setFeatureFlags } = featureFlags.actions;

export default featureFlags.reducer;

export const selectFeatureFlags = (state: RootState) => state.featureFlags;
